import { SEOHowTo } from '../../types'
import { makeId } from '../utils'

export interface SEOHowToInput {
  name: string
  canonicalUrl: string
  stepItems: {
    name: string
    text: string
  }[]
}

export const getHowTo = ({ name, stepItems, canonicalUrl }: SEOHowToInput): SEOHowTo => ({
  '@type': 'HowTo',
  '@id': makeId(canonicalUrl, 'howto'),
  name,
  step: stepItems.map((step) => ({
    '@type': 'HowToStep',
    ...step,
  })),
})
